import React from 'react'
import { CircularProgress, Box, Col, Typography, Row } from '@vibialighting/ui-kit'

const layerStyles = {
	local: {
		width: '100%',
		height: '100%',
		opacity: 0.70,
		zIndex: 7,
		position: 'absolute',
		backgroundColor: 'rgba(255, 2555, 255,  0.9)',
	},
	overall: {
		width: '100vw',
		height: '100vh',
		opacity: 0.70,
		zIndex: 200,
		position: 'fixed',
		top: 0,
		left: 0,
		backgroundColor: 'rgba(255, 2555, 255,  0.9)',
	}
}

const LoadingLayer = (props) => {
	const {
		message,
		size = 80,
		thickness = 6,
		overAll = false,
	} = props

	return (
		<Box style={overAll ? { ...layerStyles.overall } : { ...layerStyles.local }}>
			<Row disableGutters justifyContent="center" alignItems="center" style={{ height: '100%' }}>
				<Col width="auto">
					<Box hAlign="center">
						<CircularProgress thickness={thickness} size={size} />
					</Box>
					{message &&
						<Box paddingTop={5}>
							<Typography component="p" variant="h4" weight="regular"> {message} </Typography>
						</Box>
					}
				</Col>
			</Row>
		</Box>
	)
}

export default LoadingLayer